import Login from '../views/Login/Login'
import Dashboard from '../layouts/Dashboard/Dashboard';

const indexRoutes = [
    { path: '/login', name: 'Login', component: Login },
    { path: '/', name: 'Home', component: Dashboard },
];

export default indexRoutes;
